import { Record } from "./fable_modules/fable-library.3.7.20/Types.js";
import { lambda_type, unit_type, bool_type, record_type, string_type } from "./fable_modules/fable-library.3.7.20/Reflection.js";
import { nonSeeded } from "./fable_modules/fable-library.3.7.20/Random.js";
import { createObj, stringHash, uncurry, int32ToString } from "./fable_modules/fable-library.3.7.20/Util.js";
import { createElement } from "react";
import * as react from "react";
import * as location_1 from "../src/location.js";
import { choose, fold } from "./fable_modules/fable-library.3.7.20/Array.js";
import { isNullOrWhiteSpace, printf, toText, substring, split } from "./fable_modules/fable-library.3.7.20/String.js";
import { RouterModule_router, RouterModule_urlSegments, RouterModule_nav } from "./fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { singleton as singleton_1, toArray, contains, map, ofArray } from "./fable_modules/fable-library.3.7.20/List.js";
import { baseUrl } from "./HttpV2.js";
import { $007CStartsWith$007C_$007C } from "./fable_modules/Svea.Dry.Fable.1.0.4/Tools.fs.js";
import { DOMAttr, HTMLAttr } from "./fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "./fable_modules/fable-library.3.7.20/MapUtil.js";
import { stackClasses, logei, classNames, delayAsync, memoize } from "./Utils.js";
import { getMaterialIcon, SveaIcon, renderSveaIcon, textDotsLoading, Size, getMaterialIconBySize, dotsLoading } from "./ViewUtils.js";
import { FunctionComponent_Of_Z5A158BBF } from "./fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { reduxStore, useDispatch, useSelector } from "./Redux/Store.js";
import { loadEffect, LoadState$2, SaveStatus, $007CPrefix$007C_$007C, LoadState_zip, getTranslationFrom } from "./Global.js";
import { pop } from "./Redux/Reducers/ModalsReducer.js";
import { MessageType, renderAsModal } from "./Components/Modals/InfoMessage/InfoMessage.js";
import { renderModal as renderModal_1 } from "./Components/Modals/Choice/Choice.js";
import { SessionResponse$reflection, Page, Page$reflection } from "./Model.js";
import { warning, error } from "./Components/Message/Message.js";
import { LinkAccountProps } from "./Containers/LinkAccount/View.js";
import { CustomerContractProps, view as view_1 } from "./Containers/CustomerContract/View.js";
import { ContractsProps } from "./Containers/Contracts/View.js";
import { logError, LogErrorDTO, loadTranslationsThunk, loadSessionContextThunk } from "./Api/Global.js";
import { ClientSettingsProps } from "./Containers/ClientSettings/View.js";
import { WarningsProps } from "./Containers/StatusAndWarnings/View.js";
import { SuspenseProps } from "./Containers/Suspense/View.js";
import { MortgageValidationProps } from "./Containers/MortgageValidation/View.js";
import { NumberInventoryProps } from "./Containers/NumberInventory/View.js";
import { ReportsProps } from "./Containers/Reports/View.js";
import { ImportsProps } from "./Containers/Imports/View.js";
import { AdmittanceUsersProps } from "./Containers/AdmittanceUsers/View.js";
import { ClientDetailsProps } from "./Containers/ClientDetails/View.js";
import { renderLogin } from "./Containers/Login/View.js";
import { startImmediate } from "./fable_modules/fable-library.3.7.20/Async.js";
import { Helpers_equalsButFunctions } from "./fable_modules/Fable.React.7.4.3/Fable.React.Helpers.fs.js";
import { parseUrl } from "./Routes.js";
import { singleton } from "./fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { loadSelectedLanguage as loadSelectedLanguage_1, loadSelectedRole as loadSelectedRole_1, checkActiveSession } from "./Api.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.3.7.20/Choice.js";
import { SimpleJson_tryParse } from "./fable_modules/Fable.SimpleJson.3.21.0/SimpleJson.fs.js";
import { Convert_fromJson } from "./fable_modules/Fable.SimpleJson.3.21.0/Json.Converter.fs.js";
import { createTypeInfo } from "./fable_modules/Fable.SimpleJson.3.21.0/TypeInfo.Converter.fs.js";
import { difference, isEmpty } from "./fable_modules/fable-library.3.7.20/Set.js";
import { useInterval } from "./Components/Hooks/UseInterval.js";
import { renderNavbar } from "./Navbar.js";
import { ModalSize, getModalContainer, modal as modal_1 } from "./Components/Modal/Modal.js";
import { CollapseProps, collapse } from "./Components/Collapse/Collapse.js";
import { ErrorBoundary } from "react-error-boundary";
import { Provider } from "react-redux";
import { render as render_1 } from "react-dom";
import "../src/App.scss";

export class Location extends Record {
    constructor(hash, host, hostname, href, origin, pathname, port, protocol, search) {
        super();
        this.hash = hash;
        this.host = host;
        this.hostname = hostname;
        this.href = href;
        this.origin = origin;
        this.pathname = pathname;
        this.port = port;
        this.protocol = protocol;
        this.search = search;
    }
}

export function Location$reflection() {
    return record_type("App.View.Location", [], Location, () => [["hash", string_type], ["host", string_type], ["hostname", string_type], ["href", string_type], ["origin", string_type], ["pathname", string_type], ["port", string_type], ["protocol", string_type], ["search", string_type]]);
}


function renderIframe(urlResult, forceReload, stopReloadIframeFn, iframeUrlChangeFn) {
    let copyOfStruct, children;
    if (urlResult.tag === 0) {
        const url = urlResult.fields[0];
        const iframeId = "fenixweb-iframe";
        const key = forceReload ? ((url + "_") + ((copyOfStruct = nonSeeded().Next0(), int32ToString(copyOfStruct)))) : url;
        if (forceReload) {
            stopReloadIframeFn();
        }
        return react.createElement("iframe", {
            key: key,
            className: "fenix-iframe",
            title: "FenixWeb iframe",
            id: iframeId,
            onLoad: (_arg) => {
                const location = location_1.getIFrameLocation(iframeId);
                const iframeFriendlyUrl = fold((acc, elem) => ((acc + "/") + elem), "", choose((part) => {
                    if ((part === "FenixWeb") ? true : (part === "")) {
                        return void 0;
                    }
                    else {
                        return part;
                    }
                }, split(location.pathname, ["/"], null, 0)));
                if ((iframeFriendlyUrl === "") && (location.hash.indexOf("#/") === 0)) {
                    RouterModule_nav(ofArray(split(substring(location.hash, 1), ["/"], null, 0)), 1, 1);
                }
                else {
                    iframeUrlChangeFn(((((baseUrl + "#i") + iframeFriendlyUrl) + "/") + location.hash) + location.search);
                }
            },
            src: url,
        });
    }
    else {
        const children_2 = [(children = [toText(printf("Incorrect iFrame url: %s"))(urlResult.fields[0])], react.createElement("h3", {}, ...children))];
        return react.createElement("div", {}, ...children_2);
    }
}

function getVersionBadge$0027(_arg) {
    let activePatternResult, x;
    if (_arg == null) {
        return react.createElement(react.Fragment, {});
    }
    else {
        const url = _arg;
        const props = [new HTMLAttr(149, baseUrl + ((activePatternResult = $007CStartsWith$007C_$007C("/", url), (activePatternResult != null) ? ((x = activePatternResult, substring(x, 1))) : url))), new HTMLAttr(65, "versionBadge")];
        return react.createElement("img", keyValueList(props, 1));
    }
}

const renderVersionBadge = memoize(getVersionBadge$0027);

const LazyPages_ContractsPage = (() => {
    const elemType = react.lazy(() => import("./Containers/Contracts/View.js").then((m) => m.view).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

const LazyPages_BillingPage = (() => {
    const elemType = react.lazy(() => import("./Containers/Billing/View.js").then((m) => m.lazyView).then((x) => ({
        default: x,
    })));
    return (props_1) => {
        const comp_1 = react.Suspense;
        const props_3 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props_1)];
        return react.createElement(comp_1, props_3, ...children_1);
    };
})();

const LazyPages_ClientSettingsPage = (() => {
    const elemType = react.lazy(() => import("./Containers/ClientSettings/View.js").then((m) => m.view).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

const LazyPages_DevToolsPage = (() => {
    const elemType = react.lazy(() => import("./DevTools/Base.js").then((m) => m.lazyView).then((x) => ({
        default: x,
    })));
    return (props_1) => {
        const comp_1 = react.Suspense;
        const props_3 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props_1)];
        return react.createElement(comp_1, props_3, ...children_1);
    };
})();

const LazyPages_EditTemplatesPage = (() => {
    const elemType = react.lazy(() => import("./EditTemplate/EditTemplate.js").then((m) => m.lazyView).then((x) => ({
        default: x,
    })));
    return (props_1) => {
        const comp_1 = react.Suspense;
        const props_3 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props_1)];
        return react.createElement(comp_1, props_3, ...children_1);
    };
})();

const LazyPages_AdminPage = (() => {
    const elemType = react.lazy(() => import("./Admin/Base.js").then((m) => m.lazyView).then((x) => ({
        default: x,
    })));
    return (props_1) => {
        const comp_1 = react.Suspense;
        const props_3 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props_1)];
        return react.createElement(comp_1, props_3, ...children_1);
    };
})();

const LazyPages_RegisterPage = (() => {
    const elemType = react.lazy(() => import("./Register/Register.js").then((m) => m.lazyView).then((x) => ({
        default: x,
    })));
    return (props_1) => {
        const comp_1 = react.Suspense;
        const props_3 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props_1)];
        return react.createElement(comp_1, props_3, ...children_1);
    };
})();

const LazyPages_StatusAndWarningsPage = (() => {
    const elemType = react.lazy(() => import("./Containers/StatusAndWarnings/View.js").then((m) => m.view).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

const LazyPages_M2MSimList = (() => {
    const elemType = react.lazy(() => import("./Containers/M2M/SimList.js").then((m) => m.lazyView).then((x) => ({
        default: x,
    })));
    return (props_1) => {
        const comp_1 = react.Suspense;
        const props_3 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props_1)];
        return react.createElement(comp_1, props_3, ...children_1);
    };
})();

const LazyPages_SuspensePage = (() => {
    const elemType = react.lazy(() => import("./Containers/Suspense/View.js").then((m) => m.renderSuspense).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

const LazyPages_MortgageValidation = (() => {
    const elemType = react.lazy(() => import("./Containers/MortgageValidation/View.js").then((m) => m.renderMortgageValidation).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

const LazyPages_NumberInventory = (() => {
    const elemType = react.lazy(() => import("./Containers/NumberInventory/View.js").then((m) => m.renderNumberInventory).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

const LazyPages_Reports = (() => {
    const elemType = react.lazy(() => import("./Containers/Reports/View.js").then((m) => m.renderReports).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

const LazyPages_ImportsPage = (() => {
    const elemType = react.lazy(() => import("./Containers/Imports/View.js").then((m) => m.view).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

const LazyPages_AdmittanceUsersPage = (() => {
    const elemType = react.lazy(() => import("./Containers/AdmittanceUsers/View.js").then((m) => m.renderAdmittanceUsers).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

const LazyPages_ClientDetailsPage = (() => {
    const elemType = react.lazy(() => import("./Containers/ClientDetails/View.js").then((m) => m.renderClientDetails).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

const LazyPages_LinkAccountPage = (() => {
    const elemType = react.lazy(() => import("./Containers/LinkAccount/View.js").then((m) => m.view).then((x) => ({
        default: x,
    })));
    return (props) => {
        const comp_1 = react.Suspense;
        const props_2 = {
            fallback: dotsLoading,
        };
        const children_1 = [react.createElement(elemType, props)];
        return react.createElement(comp_1, props_2, ...children_1);
    };
})();

const renderGlobalModals = FunctionComponent_Of_Z5A158BBF(() => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const reduxDispatch = useDispatch();
    const closeModal = () => {
        reduxDispatch(pop);
    };
    const renderInfoModal = (header) => ((messageType) => ((msg) => {
        const buttonConfirm = getTranslation("Common.Close");
        return (onConfirm) => renderAsModal(header, msg, messageType, buttonConfirm, onConfirm);
    }));
    const modalsHtml = map((modal) => {
        switch (modal.tag) {
            case 0: {
                return renderInfoModal("Info")(new MessageType(0))(modal.fields[0])((_arg_1) => {
                    closeModal();
                });
            }
            case 1: {
                return renderInfoModal("Warning")(new MessageType(1))(modal.fields[0])((_arg_2) => {
                    closeModal();
                });
            }
            case 2: {
                return renderInfoModal("Error")(new MessageType(2))(modal.fields[0])((_arg_3) => {
                    closeModal();
                });
            }
            case 3: {
                const onCont = modal.fields[1];
                return renderModal_1("", modal.fields[0], getTranslation("Common.No"), getTranslation("Common.Yes"), (_arg_4) => {
                    onCont(false);
                    closeModal();
                }, (_arg_5) => {
                    onCont(true);
                    closeModal();
                });
            }
            default: {
                return react.createElement(react.Fragment, {});
            }
        }
    }, useSelector((store) => store.Modals));
    return react.createElement("div", {
        id: "global-modal-container",
    }, ...modalsHtml);
}, void 0, uncurry(2, void 0), void 0, "renderGlobalModals", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\App.fs", 194);

class PageProps extends Record {
    constructor(Page, ForceIframeReload, StopReloadIframeFn, IframeUrlChangeFn) {
        super();
        this.Page = Page;
        this.ForceIframeReload = ForceIframeReload;
        this.StopReloadIframeFn = StopReloadIframeFn;
        this.IframeUrlChangeFn = IframeUrlChangeFn;
    }
}

function PageProps$reflection() {
    return record_type("App.View.PageProps", [], PageProps, () => [["Page", Page$reflection()], ["ForceIframeReload", bool_type], ["StopReloadIframeFn", lambda_type(unit_type, unit_type)], ["IframeUrlChangeFn", lambda_type(string_type, unit_type)]]);
}

const renderPage = FunctionComponent_Of_Z5A158BBF((props) => {
    const globalDepsLoadState = useSelector((state) => state.Model.GlobalDependencies);
    const translationsLoadState = useSelector((state_1) => state_1.Model.Translations);
    const reduxDispatch = useDispatch();
    let page_7;
    const matchValue_1 = LoadState_zip(globalDepsLoadState, translationsLoadState);
    switch (matchValue_1.tag) {
        case 1: {
            page_7 = dotsLoading;
            break;
        }
        case 3: {
            page_7 = error(matchValue_1.fields[0].split(""));
            break;
        }
        case 2: {
            const globalDeps_1 = matchValue_1.fields[0][0];
            if (globalDeps_1.RequireIdsStepUp) {
                page_7 = LazyPages_LinkAccountPage(new LinkAccountProps(globalDeps_1));
            }
            else {
                const globalDeps = globalDeps_1;
                const matchValue = props.Page;
                switch (matchValue.tag) {
                    case 18: {
                        page_7 = renderIframe(matchValue.fields[0], props.ForceIframeReload, props.StopReloadIframeFn, props.IframeUrlChangeFn);
                        break;
                    }
                    case 1: {
                        page_7 = LazyPages_BillingPage({
                            GlobalDependencies: globalDeps,
                            Page: matchValue.fields[0],
                        });
                        break;
                    }
                    case 5: {
                        page_7 = view_1(new CustomerContractProps(globalDeps, matchValue.fields[0]));
                        break;
                    }
                    case 4: {
                        page_7 = LazyPages_ContractsPage(new ContractsProps(globalDeps, matchValue.fields[0]));
                        break;
                    }
                    case 2: {
                        page_7 = LazyPages_ClientSettingsPage(new ClientSettingsProps(globalDeps, matchValue.fields[0], () => {
                            reduxDispatch(loadSessionContextThunk());
                        }));
                        break;
                    }
                    case 3: {
                        page_7 = LazyPages_EditTemplatesPage({
                            ClientNr: globalDeps.ClientNr,
                        });
                        break;
                    }
                    case 6: {
                        page_7 = LazyPages_DevToolsPage({
                            IsAdminUser: globalDeps.IsAdminUser,
                            Page: matchValue.fields[0],
                        });
                        break;
                    }
                    case 7: {
                        page_7 = LazyPages_AdminPage({
                            IsAdminUser: globalDeps.IsAdminUser,
                            Page: matchValue.fields[0],
                        });
                        break;
                    }
                    case 8: {
                        page_7 = LazyPages_RegisterPage({
                            GlobalDependencies: globalDeps,
                        });
                        break;
                    }
                    case 9: {
                        page_7 = LazyPages_StatusAndWarningsPage(new WarningsProps(globalDeps, matchValue.fields[0]));
                        break;
                    }
                    case 10: {
                        page_7 = LazyPages_M2MSimList({
                            GlobalDependencies: globalDeps,
                        });
                        break;
                    }
                    case 11: {
                        page_7 = LazyPages_SuspensePage(new SuspenseProps(globalDeps));
                        break;
                    }
                    case 12: {
                        page_7 = LazyPages_MortgageValidation(new MortgageValidationProps(globalDeps));
                        break;
                    }
                    case 13: {
                        page_7 = LazyPages_NumberInventory(new NumberInventoryProps(globalDeps, matchValue.fields[0]));
                        break;
                    }
                    case 14: {
                        page_7 = LazyPages_Reports(new ReportsProps(globalDeps, matchValue.fields[0]));
                        break;
                    }
                    case 15: {
                        page_7 = LazyPages_ImportsPage(new ImportsProps(globalDeps, matchValue.fields[0]));
                        break;
                    }
                    case 16: {
                        page_7 = LazyPages_AdmittanceUsersPage(new AdmittanceUsersProps(globalDeps));
                        break;
                    }
                    case 17: {
                        page_7 = LazyPages_ClientDetailsPage(new ClientDetailsProps(globalDeps));
                        break;
                    }
                    case 20: {
                        page_7 = react.createElement("div", {}, dotsLoading);
                        break;
                    }
                    case 21: {
                        page_7 = LazyPages_LinkAccountPage(new LinkAccountProps(globalDeps));
                        break;
                    }
                    case 19: {
                        const children_4 = [react.createElement("h3", {}, "Not found.")];
                        page_7 = react.createElement("div", {}, ...children_4);
                        break;
                    }
                    default: {
                        page_7 = renderLogin();
                    }
                }
            }
            break;
        }
        default: {
            page_7 = react.createElement(react.Fragment, {});
        }
    }
    const children_7 = [renderGlobalModals(), page_7];
    return react.createElement(react.Fragment, {}, ...children_7);
}, void 0, uncurry(2, void 0), void 0, "renderPage", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\App.fs", 267);

const requiresReloadBoxHtml = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_1, children_3, children_5;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const shouldShow = react.useState(false);
    if (props.RequiresPageReload) {
        if (!(shouldShow[0])) {
            startImmediate(delayAsync(2000, () => {
                shouldShow[1](true);
            }));
        }
        const classes = classNames(ofArray([["requires-reload", true], ["requires-reload--show", shouldShow[0]]]));
        const children_7 = [(children_1 = [getMaterialIconBySize("close", new Size(1))], react.createElement("div", {
            className: "requires-reload__close",
            onClick: (e) => {
                shouldShow[1](false);
                props.OnCloseClick(e);
            },
        }, ...children_1)), (children_3 = [getTranslation("CustomerContract.NewVersionAvailable")], react.createElement("span", {}, ...children_3)), (children_5 = [getTranslation("CustomerContract.Refresh")], react.createElement("span", {
            className: "requires-reload__refresh",
            onClick: (_arg) => {
                window.location.reload();
            },
        }, ...children_5))];
        return react.createElement("div", {
            className: classes,
        }, ...children_7);
    }
    else {
        return react.createElement(react.Fragment, {});
    }
}, "ReloadBox", Helpers_equalsButFunctions, void 0, "requiresReloadBoxHtml", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\App.fs", 300);

const renderSiteWideMessage = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_2;
    let shouldShow;
    let arg_1;
    const matchValue = props.SiteWideMessage;
    arg_1 = ((matchValue == null) ? false : (!isNullOrWhiteSpace(matchValue)));
    shouldShow = react.useState(arg_1);
    react.useEffect(() => {
        shouldShow[1](true);
    }, [props.SiteWideMessage]);
    const matchValue_1 = props.SiteWideMessage;
    let pattern_matching_result, message_1;
    if (matchValue_1 != null) {
        if (!isNullOrWhiteSpace(matchValue_1)) {
            pattern_matching_result = 0;
            message_1 = matchValue_1;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            const classes = classNames(ofArray([["site-wide-message", true], ["d-none", !(shouldShow[0])]]));
            const children_4 = [react.createElement("div", {
                className: "site-wide-message__message",
            }, message_1), (children_2 = [getMaterialIconBySize("highlight_off", new Size(3))], react.createElement("div", {
                className: "site-wide-message__close",
                onClick: (_arg) => {
                    shouldShow[1](false);
                },
            }, ...children_2))];
            return react.createElement("div", {
                className: classes,
            }, ...children_4);
        }
        case 1: {
            return react.createElement(react.Fragment, {});
        }
    }
}, "SiteWideMessage", Helpers_equalsButFunctions, void 0, "renderSiteWideMessage", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\App.fs", 325);

function iframeUrlToHash(str_mut) {
    iframeUrlToHash:
    while (true) {
        const str = str_mut;
        const activePatternResult = $007CPrefix$007C_$007C("/", str);
        if (activePatternResult != null) {
            const remains = activePatternResult;
            str_mut = remains;
            continue iframeUrlToHash;
        }
        else {
            return "#i/" + str;
        }
        break;
    }
}

const renderView = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_10, children_8, elements, children_18, children_14;
    const reduxDispatch = useDispatch();
    const reloadSessionContext = () => {
        reduxDispatch(loadSessionContextThunk());
    };
    const sessionContextLoadState = useSelector((state) => state.Model.SessionContext);
    const translationsLoadState = useSelector((state_1) => state_1.Model.Translations);
    let currentPageState;
    const arg_1 = (sessionContextLoadState.tag === 1) ? (new Page(20)) : ((sessionContextLoadState.tag === 3) ? (new Page(20)) : ((sessionContextLoadState.tag === 2) ? parseUrl(RouterModule_urlSegments(window.location.hash, 1)) : (new Page(20))));
    currentPageState = react.useState(arg_1);
    const ugPickerSaveState = react.useState(new SaveStatus(0));
    const siteWideMessageState = react.useState(void 0);
    const requiresPageReloadState = react.useState(false);
    const fableScriptsRef = react.useRef(void 0);
    const forceIframeReloadState = react.useState(false);
    const shouldRenderLoginScreenState = react.useState(false);
    const loadActiveSession = () => {
        startImmediate(singleton.Delay(() => singleton.Bind(checkActiveSession(), (_arg_2) => {
            let matchValue_3, matchValue_5, hasScriptChanges;
            const result_2 = _arg_2;
            switch (result_2.tag) {
                case 2: {
                    logei(toText(printf("ActiveSession responded with Error msg: \u0027%s\u0027"))(result_2.fields[0]));
                    return singleton.Zero();
                }
                case 0: {
                    shouldRenderLoginScreenState[1](false);
                    let matchValue_4;
                    try {
                        matchValue_4 = (new FSharpResult$2(0, (matchValue_3 = SimpleJson_tryParse(result_2.fields[0]), (matchValue_3 != null) ? Convert_fromJson(matchValue_3, createTypeInfo(SessionResponse$reflection())) : (() => {
                            throw (new Error("Couldn\u0027t parse the input JSON string because it seems to be invalid"));
                        })())));
                    }
                    catch (ex) {
                        matchValue_4 = (new FSharpResult$2(1, ex.message));
                    }
                    if (matchValue_4.tag === 0) {
                        const sessionResponse = matchValue_4.fields[0];
                        return singleton.Combine((matchValue_5 = fableScriptsRef.current, (matchValue_5 != null) ? ((hasScriptChanges = (!isEmpty(difference(matchValue_5, sessionResponse.FableScripts))), hasScriptChanges ? ((requiresPageReloadState[1](true), (fableScriptsRef.current = sessionResponse.FableScripts, singleton.Zero()))) : ((singleton.Zero())))) : ((fableScriptsRef.current = sessionResponse.FableScripts, singleton.Zero()))), singleton.Delay(() => {
                            let hasSiteWideChanges;
                            const matchValue_6 = [siteWideMessageState[0], sessionResponse.SiteWideMessage];
                            let pattern_matching_result;
                            if (matchValue_6[0] != null) {
                                if (matchValue_6[1] != null) {
                                    if (matchValue_6[0] !== matchValue_6[1]) {
                                        pattern_matching_result = 1;
                                    }
                                    else {
                                        pattern_matching_result = 2;
                                    }
                                }
                                else {
                                    pattern_matching_result = 0;
                                }
                            }
                            else if (matchValue_6[1] != null) {
                                pattern_matching_result = 0;
                            }
                            else {
                                pattern_matching_result = 2;
                            }
                            switch (pattern_matching_result) {
                                case 0: {
                                    hasSiteWideChanges = true;
                                    break;
                                }
                                case 1: {
                                    hasSiteWideChanges = true;
                                    break;
                                }
                                case 2: {
                                    hasSiteWideChanges = false;
                                    break;
                                }
                            }
                            if (hasSiteWideChanges) {
                                siteWideMessageState[1](sessionResponse.SiteWideMessage);
                                return singleton.Zero();
                            }
                            else {
                                return singleton.Zero();
                            }
                        }));
                    }
                    else {
                        logei(matchValue_4.fields[0]);
                        return singleton.Zero();
                    }
                }
                default: {
                    if (shouldRenderLoginScreenState[0]) {
                        return singleton.Zero();
                    }
                    else {
                        shouldRenderLoginScreenState[1](true);
                        return singleton.Zero();
                    }
                }
            }
        })));
    };
    useInterval(loadActiveSession, 5000);
    react.useEffect(() => {
        reduxDispatch(loadSessionContextThunk());
        loadActiveSession();
    }, []);
    react.useEffect(() => {
        if (sessionContextLoadState.tag === 2) {
            const sessionContext = sessionContextLoadState.fields[0];
            reduxDispatch(loadTranslationsThunk(sessionContext.SelectedLanguage, sessionContext.LanguageCode));
            const arg_8 = parseUrl(RouterModule_urlSegments(window.location.hash, 1));
            currentPageState[1](arg_8);
        }
    }, [sessionContextLoadState]);
    react.useEffect(() => {
        if (sessionContextLoadState.tag === 2) {
            ugPickerSaveState[1](new SaveStatus(2));
        }
    }, [sessionContextLoadState]);
    if (shouldRenderLoginScreenState[0]) {
        return renderLogin();
    }
    else {
        switch (sessionContextLoadState.tag) {
            case 1: {
                return react.createElement("div", {
                    className: "p-4",
                }, dotsLoading);
            }
            case 3: {
                return react.createElement("div", {
                    className: "p-4",
                }, dotsLoading);
            }
            case 2: {
                const context = sessionContextLoadState.fields[0];
                const htmlElement = document.querySelector("html");
                htmlElement.setAttribute("lang", context.SelectedLanguage);
                const navbarHtml = renderNavbar((role) => {
                    let matchValue, clientNr;
                    startImmediate((matchValue = role.ClientNr, (matchValue == null) ? singleton.Return() : ((clientNr = (matchValue | 0), singleton.Delay(() => singleton.Bind(loadSelectedRole_1(clientNr, role.InvoiceeNr), (_arg) => {
                        const result = _arg;
                        if (result.tag === 1) {
                            logei(["Error LoadedSelectedLanguage with msg: ", result.fields[0]]);
                            return singleton.Zero();
                        }
                        else {
                            reloadSessionContext();
                            const currentUrl = RouterModule_urlSegments(window.location.hash, 1);
                            if (contains("CustomerContract", currentUrl, {
                                Equals: (x, y) => (x === y),
                                GetHashCode: stringHash,
                            })) {
                                RouterModule_nav(ofArray([]), 1, 1);
                                return singleton.Zero();
                            }
                            else if (contains("i", currentUrl, {
                                Equals: (x_1, y_1) => (x_1 === y_1),
                                GetHashCode: stringHash,
                            })) {
                                window.location.reload();
                                RouterModule_nav(ofArray(toArray(currentUrl)), 1, 1);
                                return singleton.Zero();
                            }
                            else {
                                RouterModule_nav(ofArray(toArray(currentUrl)), 1, 1);
                                return singleton.Zero();
                            }
                        }
                    }))))));
                }, (language) => {
                    startImmediate(singleton.Delay(() => singleton.Bind(loadSelectedLanguage_1(language), (_arg_1) => {
                        const result_1 = _arg_1;
                        if (result_1.tag === 1) {
                            logei(["Error LoadedSelectedLanguage with msg: ", result_1.fields[0]]);
                            return singleton.Zero();
                        }
                        else {
                            reloadSessionContext();
                            return singleton.Zero();
                        }
                    })));
                }, context);
                const versionBadgeHtml = renderVersionBadge(context.VersionBadgeUrl);
                let contentHtml_1;
                if (context.ClientConfig != null) {
                    if ((currentPageState[0]).tag === 18) {
                        contentHtml_1 = renderPage(new PageProps(currentPageState[0], forceIframeReloadState[0], () => {
                            forceIframeReloadState[1](false);
                        }, (fullUrl) => {
                            history.replaceState(null, null, fullUrl);
                        }));
                    }
                    else {
                        let ugPickerSaveModalHtml;
                        const matchValue_10 = ugPickerSaveState[0];
                        switch (matchValue_10.tag) {
                            case 3:
                            case 2: {
                                ugPickerSaveModalHtml = react.createElement(react.Fragment, {});
                                break;
                            }
                            case 1: {
                                ugPickerSaveModalHtml = modal_1(true, getModalContainer(new ModalSize(0), (children_10 = [(children_8 = [getTranslationFrom(translationsLoadState, "Common.ChangingClient") + "..."], react.createElement("h4", {}, ...children_8)), dotsLoading], react.createElement("div", {
                                    className: "loading-ug-modal",
                                }, ...children_10))));
                                break;
                            }
                            default: {
                                ugPickerSaveModalHtml = react.createElement(react.Fragment, {});
                            }
                        }
                        const children_12 = [renderPage(new PageProps(currentPageState[0], forceIframeReloadState[0], () => {
                            forceIframeReloadState[1](false);
                        }, (fullUrl_1) => {
                            history.replaceState(null, null, fullUrl_1);
                        })), ugPickerSaveModalHtml];
                        contentHtml_1 = react.createElement("div", {
                            className: "inner-wrapper",
                        }, ...children_12);
                    }
                }
                else {
                    const children_5 = [warning("ClientNr not available, please choose a different one.".split(""))];
                    contentHtml_1 = react.createElement("div", {
                        className: "m-4",
                    }, ...children_5);
                }
                return RouterModule_router(createObj(ofArray([["onUrlChanged", (arg_10) => {
                    const arg_9 = parseUrl(arg_10);
                    currentPageState[1](arg_9);
                }], (elements = singleton_1((children_18 = [(children_14 = [renderSiteWideMessage({
                    SiteWideMessage: siteWideMessageState[0],
                }), navbarHtml, versionBadgeHtml], react.createElement("div", {}, ...children_14)), requiresReloadBoxHtml({
                    OnCloseClick: (_arg_3) => {
                        requiresPageReloadState[1](false);
                    },
                    RequiresPageReload: requiresPageReloadState[0],
                }), react.createElement("div", {
                    className: "content-wrapper",
                }, contentHtml_1)], react.createElement("div", {
                    className: "h-100",
                }, ...children_18))), ["application", react.createElement(react.Fragment, {}, ...elements)])])));
            }
            default: {
                return react.createElement(react.Fragment, {});
            }
        }
    }
}, void 0, uncurry(2, void 0), void 0, "renderView", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\App.fs", 558);

export const errorFallbackComponent = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_73, children_3, children_53, props_16, children_15, props_12, children_11, children_23, props_18, children_17, props_20, children_29, props_26, children_25, props_28, children_37, props_32, children_31, children_51, props_40, children_39, children_49, children_71, props_58, children_63, children_69;
    const errorIdLoadState = react.useState(new LoadState$2(0));
    const globalDepsLoadState = useSelector((state) => state.Model.GlobalDependencies);
    const clientNr = ((globalDepsLoadState.tag === 2) ? globalDepsLoadState.fields[0].ClientNr : 0) | 0;
    const dto = new LogErrorDTO(toText(printf("[FenixWeb Fable crashed]\r\n%s"))(props.error.message), props.error.stack, document.location.href);
    react.useEffect(() => {
        loadEffect(() => logError(clientNr, dto), (arg_1) => {
            errorIdLoadState[1](arg_1);
        });
    }, []);
    let errorIdHtml;
    const matchValue = errorIdLoadState[0];
    switch (matchValue.tag) {
        case 1: {
            errorIdHtml = textDotsLoading;
            break;
        }
        case 3: {
            errorIdHtml = error(matchValue.fields[0].split(""));
            break;
        }
        case 2: {
            errorIdHtml = react.createElement("span", {}, matchValue.fields[0]);
            break;
        }
        default: {
            errorIdHtml = react.createElement(react.Fragment, {});
        }
    }
    const children_75 = [(children_73 = [(children_3 = [renderSveaIcon(new SveaIcon(11))], react.createElement("div", {
        className: "inner__crash",
    }, ...children_3)), react.createElement("h3", {
        className: "text-center",
    }, "Well, this is embarrassing..."), react.createElement("p", {}, "Sorry, this is not working properly. We now know about this mistake. The problem has been logged and a developer has been emailed to fix it."), react.createElement("p", {}, "In the meantime, here is what you can do:"), (children_53 = [(props_16 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "pointer", "fit-content"]))), new DOMAttr(40, (_arg) => {
        props.resetErrorBoundary();
    })], (children_15 = [(props_12 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "mr-2"])))], (children_11 = [getMaterialIcon("restore_page")], react.createElement("div", keyValueList(props_12, 1), ...children_11))), react.createElement("b", {
        className: "link-blue",
    }, "Try showing the page immediately")], react.createElement("li", keyValueList(props_16, 1), ...children_15))), (children_23 = [(props_18 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "mr-2"])))], (children_17 = [getMaterialIcon("refresh")], react.createElement("div", keyValueList(props_18, 1), ...children_17))), (props_20 = [new HTMLAttr(94, window.location.href), new HTMLAttr(65, "font-weight-bold"), new DOMAttr(40, (_arg_1) => {
        window.location.reload();
    })], react.createElement("a", keyValueList(props_20, 1), "Refresh the page ")), react.createElement("span", {}, " (sometimes this helps).")], react.createElement("li", {
        className: "d-flex",
    }, ...children_23)), (children_29 = [(props_26 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "mr-2"])))], (children_25 = [getMaterialIcon("first_page")], react.createElement("div", keyValueList(props_26, 1), ...children_25))), (props_28 = [new HTMLAttr(94, window.location.origin), new HTMLAttr(65, "font-weight-bold"), new DOMAttr(40, (_arg_2) => {
        window.location.reload();
    })], react.createElement("a", keyValueList(props_28, 1), "Go back to the startpage and do some other work."))], react.createElement("li", {
        className: "d-flex",
    }, ...children_29)), (children_37 = [(props_32 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "mr-2"])))], (children_31 = [getMaterialIcon("schedule")], react.createElement("div", keyValueList(props_32, 1), ...children_31))), react.createElement("b", {}, "Try again "), react.createElement("span", {}, "in 30 minutes.")], react.createElement("li", {
        className: "d-flex",
    }, ...children_37)), (children_51 = [(props_40 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "mr-2"])))], (children_39 = [getMaterialIcon("email")], react.createElement("div", keyValueList(props_40, 1), ...children_39))), react.createElement("b", {}, "Email us "), (children_49 = [react.createElement("span", {}, "at "), react.createElement("a", {
        href: "mailto:support-sbs@svea.com",
    }, "support-sbs@svea.com"), react.createElement("span", {}, " and tell us what happened.")], react.createElement("div", {}, ...children_49))], react.createElement("li", {
        className: "d-flex",
    }, ...children_51))], react.createElement("ul", {
        className: "inner__action-list",
    }, ...children_53)), (children_71 = [react.createElement("p", {
        className: "font-weight-bold",
    }, "Technical details"), (props_58 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center"])))], react.createElement("div", keyValueList(props_58, 1), "ErrorId: ", errorIdHtml)), (children_63 = [collapse(new CollapseProps(react.createElement("div", {
        className: "small",
    }, props.error.message), react.createElement("span", {}, "Error message"), false))], react.createElement("div", {
        className: "error-details__margins",
    }, ...children_63)), (children_69 = [collapse(new CollapseProps(react.createElement("div", {
        className: "small",
    }, props.error.stack), react.createElement("span", {}, "Stack trace"), false))], react.createElement("div", {
        className: "error-details__margins",
    }, ...children_69))], react.createElement("div", {
        className: "inner__error-details",
    }, ...children_71))], react.createElement("div", {
        className: "error-boundary__inner",
    }, ...children_73))];
    return react.createElement("div", {
        className: "error-boundary",
    }, ...children_75);
}, "ErrorFallback", uncurry(2, void 0), void 0, "errorFallbackComponent", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\App.fs", 676);

export const view = (() => {
    const reactErrorBoundary = createElement(ErrorBoundary, {
        FallbackComponent: errorFallbackComponent,
        children: renderView({
            NoPropsHere: true,
        }),
        onError: (value) => {
        },
    });
    const props = {
        store: reduxStore,
    };
    return react.createElement(Provider, props, reactErrorBoundary);
})();

render_1(view, document.getElementById("elmish-app"));

